module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/club-injuries/club-injuries.component.css
// module id = ./src/app/pages/club-injuries/club-injuries.component.css
// module chunks = main